<template>
  <div class="AssignmentReportTasks assignment-reports-tasks">
    <v-card
      v-for="task in tasks"
      :key="task._id"
      rounded="xl"
      class="assignment-reports-task mt-3 mb-5"
    >
      <div class="assignment-reports-task__inner">
        <AssignmentTask
          :task="task"
          :answer="getTaskAnswerValues(task)"
          :achieved-points="getTaskAchievedPoints(task)"
          :report="report"
          @image-preview="openImagePreview"
        />
      </div>
    </v-card>

    <PreviewImageDialog
      v-model="imagePreview.active"
      title="Preview image"
      :src="imagePreview.src"
    />
  </div>
</template>

<script>
export default {
  name: 'AssignmentReportTasks',
  components: {
    AssignmentTask: () => import('@/components/assignments/AssignmentTask'),
    PreviewImageDialog: () => import('@/components/modals/PreviewImageDialog'),
  },
  props: {
    assignmentId: {
      type: String,
      required: true,
    },
    tasks: {
      type: Array,
      required: true,
    },
    report: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      imagePreview: {
        active: false,
        src: null,
      },
    };
  },
  methods: {
    getTaskAnswer(task) {
      return this.report.answers.find(a => a.taskId === task._id);
    },
    getTaskAnswerValues(task) {
      return this.getTaskAnswer(task)?.values;
    },
    getTaskAchievedPoints(task) {
      return this.getTaskAnswer(task)?.points;
    },
    openImagePreview(src) {
      Object.assign(this.imagePreview, { active: true, src });
    },
  },
};
</script>

<style scoped lang="scss">
.assignment-reports-task {
  padding: 8px;
  background: linear-gradient(255.54deg, #089DCB 0.54%, #3FD1FF 98.08%);

  &._correct {
    background: linear-gradient(255.54deg, #08cb0b 0.54%, #52ff3f 98.08%);
  }

  &._wrong {
    background: linear-gradient(255.54deg, #cb0808 0.54%, #ff3f3f 98.08%);
  }

  &__inner {
    background: #FFFFFF;
    box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.1);
    border-radius: 25px;
    padding: 4px;
  }
}
</style>
